module.exports = __webpack_public_path__ + "static/media/great.5542afd5.png";